<div>
    <div>
        <label for="name">Ingredient Name</label>
        <input type="text" class="form-control" [(ngModel)]="name">
    </div>
    <div>
        <label for="foodCode">Food Code</label>
        <input type="text" class="form-control" [(ngModel)]="foodCode">
    </div>
    <div>
        <label for="type">Type</label>
        <!-- <select name="type" id="" [(ngModel)]="type" class="form-select">
            <option value="" disabled selected>Select one</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
        </select> -->
        <ng-select class="multi-select" [items]="data"
        bindLabel="ingredient_name" bindValue="ingredient_id" [multiple]="false"
        groupBy="selectedAllGroup" [selectableGroup]="true"
        placeholder="Select appropriate type"
        (change)="ingredientDataHandeler( $event)" name="Dietary"
        [(ngModel)]="indredientType">
        <ng-template ng-optgroup-tmp let-item="item" let-item$="item$"
            let-index="index">

        </ng-template>
    </ng-select>
    </div>
    <div class="pop-btn-div">
        <button (click)="close()" class="btn btn-outline-secondary">Close</button>
        <button (click)="addNew()" class="btn btn-outline-success">Add New</button>
    </div>
</div>